exports = module.exports = require("../../../css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n.spinner[data-v-714173ee] {\n  box-sizing: border-box;\n  border-radius: 100%;\n  border: 10px solid rgba(255, 255, 255, 0.2);\n  animation: circle-2-spin-data-v-714173ee 1s infinite linear;\n}\n@keyframes circle-2-spin-data-v-714173ee {\n100% {\n    transform: rotate(360deg);\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-714173ee","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loading-spinner/node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/vue-loading-spinner/src/components/Circle2.vue
// module id = 266
// module chunks = 2